import axios from "axios";
import { jwtDecode } from "jwt-decode";

const baseURL = process.env.REACT_APP_API_BASE_URL;

const getAuthContext = () => {
  const rawToken =
    localStorage.getItem("jwtToken") ||
    localStorage.getItem("authToken") ||
    sessionStorage.getItem("token");

  if (!rawToken) {
    throw new Error("Token nao encontrado.");
  }

  const token = rawToken.startsWith("Bearer ") ? rawToken.slice(7) : rawToken;
  const decoded = jwtDecode(token);

  return {
    token,
    idClienteAipim:
      decoded?.id_cliente ||
      decoded?.idCliente ||
      decoded?.idClienteAipim ||
      decoded?.cliente_id ||
      null,
    role: decoded?.role || null,
  };
};

const request = async (method, path, { params, data } = {}) => {
  const { token } = getAuthContext();

  const response = await axios({
    method,
    url: `${baseURL}${path}`,
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    params,
    data,
  });

  return response?.data;
};

const listUsuarios = async () => {
  const { idClienteAipim } = getAuthContext();
  return request("get", "/usuarios/lista-usuarios", {
    params: { idClienteAipim },
  });
};

const createUsuario = async (payload) => {
  const { idClienteAipim } = getAuthContext();
  return request("post", "/usuarios", {
    data: {
      idClienteAipim,
      ...payload,
    },
  });
};

const updateUsuario = async (payload) => {
  const { idClienteAipim } = getAuthContext();
  return request("put", "/usuarios", {
    data: {
      idClienteAipim,
      ...payload,
    },
  });
};

const listProdutosPermissao = async () => request("get", "/usuarios/produtos-permissao");

const listProdutosPermitidos = async (idUsuario) =>
  request("get", "/usuarios/produtos-permitidos", {
    params: { id_usuario: idUsuario },
  });

const updateProdutosPermitidos = async ({ idUsuario, produtos }) =>
  request("put", "/usuarios/produtos-permitidos", {
    data: {
      idUsuario,
      produtos,
    },
  });

const usuariosService = {
  getAuthContext,
  listUsuarios,
  createUsuario,
  updateUsuario,
  listProdutosPermissao,
  listProdutosPermitidos,
  updateProdutosPermitidos,
};

export default usuariosService;
